export const GET_DOCUSIGN_ENVELOPES = "";
export const ADD_DOCUSIGN_ENVELOPE = "/admin_requests/create-envelope";
